import React from 'react';
import { Link } from 'react-router';
import AppConstants from '../../constants/constants';
import AppRoutes from '../../routes/routes';

export default props => {
  let list = props.data.map((data, key) => {
    let url = `${AppRoutes[data.type + 's']}${data.slug}`;
    let urlTag = <Link to={url}>{data.title}</Link>;

    if (data.type == 'checklist') {
      urlTag = <Link to={`${url}?highlight-text=${props.searchValue}`}>{data.title}</Link>;
    }

    if (data.type == 'chapter') {
      urlTag = (
        <Link to={`${AppRoutes.chapters}${data.slug}`}>{data.title}</Link>
      );
    }

    if (data.type == 'topic') {
      urlTag = (
        <Link to={`${AppRoutes.explore}?open=${data.slug}`}>{data.title}</Link>
      );
    }

    return <li key={`${data.type}-${data.slug}`} style={{ margin: '4px 0' }}>
      {React.cloneElement(urlTag, {
        style: {
          display: 'block',
          padding: '8px 12px',
          color: '#374151',
          textDecoration: 'none',
          borderRadius: '8px',
          fontSize: '14.5px',
          fontWeight: '500',
          transition: 'background-color 150ms ease, color 150ms ease'
        },
        onMouseEnter: e => {
          e.target.style.backgroundColor = '#EFF6FF';
          e.target.style.color = '#2563EB';
        },
        onMouseLeave: e => {
          e.target.style.backgroundColor = 'transparent';
          e.target.style.color = '#374151';
        }
      })}
    </li>;
  });

  return (
    <div className="search-suggestions-item" style={{ marginBottom: '24px' }}>
      <h3 style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '12px',
        fontWeight: '600',
        color: '#9CA3AF',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        borderBottom: '1px solid #E5E7EB',
        paddingBottom: '8px',
        marginBottom: '8px',
        marginTop: 0
      }}>
        <span>{props.title}</span>
        <Link
          to={{
            pathname: AppRoutes.search,
            query: {
              q: props.searchValue,
              page: AppConstants.DEFAULTSEARCHPAGE,
              per_page: AppConstants.PERPAGE,
              filter: props.title.toLowerCase()
            }
          }}
          className="view-more"
          style={{
            fontSize: '11px',
            color: '#2563EB',
            textDecoration: 'none',
            textTransform: 'none',
            letterSpacing: 'normal'
          }}
        >
          View all
        </Link>
      </h3>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>{list}</ul>
    </div>
  );
};
